import { createApp } from "vue";
import App from "./App.vue";
import "./styles/global.css"; // Import global styles
import router from "./router";

const app = createApp(App);
app.use(router);
app.mount("#app");
